import { Component, OnInit, Input, HostListener } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-gallery",
  templateUrl: "./gallery.component.html",
  styleUrls: ["./gallery.component.scss"]
})
export class GalleryComponent implements OnInit {
  @Input() folder: string;
  @Input() picNum: number;
  @Input() thumbName = "thumb";
  @Input() picPath: string;

  thumbArray: Array<any> = [];
  galleryOpened = false;
  selectedImgIndex: number;
  selectedImg: any;

  constructor(private sanitization: DomSanitizer) {}

  ngOnInit() {
    if (Number(this.picNum) === 1 && this.picPath) {
      let url = this.sanitization.bypassSecurityTrustStyle(
        'url("./././assets/imgs/' + this.folder + "/" + this.picPath + '")'
      );
      this.thumbArray.push(url);
    } else {
      for (var i = 1; i <= this.picNum; i++) {
        let url = this.sanitization.bypassSecurityTrustStyle(
          'url("./././assets/imgs/' +
            this.folder +
            "/" +
            this.thumbName +
            " (" +
            i +
            ').jpg")'
        );
        this.thumbArray.push(url);
      }
    }
  }

  openGallery(index: number) {
    this.galleryOpened = true;
    this.selectedImgIndex = index + 1;
    let url = "";
    if (Number(this.picNum) > 1) {
      url =
        'url("./././assets/imgs/' +
        this.folder +
        "/img (" +
        this.selectedImgIndex +
        ').jpg")';
    } else {
      url = 'url("./././assets/imgs/' + this.folder + "/" + this.picPath + '")';
    }
    this.selectedImg = this.sanitization.bypassSecurityTrustStyle(url);
  }

  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.galleryOpened) {
      if (event.key === "ArrowRight") {
        this.next();
      }
      if (event.key === "ArrowLeft") {
        this.prev();
      }
    }
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (
      this.galleryOpened &&
      !event.target.classList.contains("fas") &&
      !event.target.classList.contains("img-thumb")
    ) {
      this.close();
    }
  }

  close() {
    this.galleryOpened = false;
  }

  next() {
    this.selectedImgIndex++;
    if (this.selectedImgIndex > this.picNum) {
      this.selectedImgIndex = 1;
    }
    this.selectedImg = this.sanitization.bypassSecurityTrustStyle(
      'url("./././assets/imgs/' +
        this.folder +
        "/img (" +
        this.selectedImgIndex +
        ').jpg")'
    );
  }
  prev() {
    this.selectedImgIndex--;
    if (this.selectedImgIndex < 1) {
      this.selectedImgIndex = this.picNum;
    }
    this.selectedImg = this.sanitization.bypassSecurityTrustStyle(
      'url("./././assets/imgs/' +
        this.folder +
        "/img (" +
        this.selectedImgIndex +
        ').jpg")'
    );
  }
}
